// extracted by mini-css-extract-plugin
export default {"secondaryText":"contracts_secondaryText__3GHRb","textContainer":"contracts_textContainer__WVuY7","progressBarContainer":"contracts_progressBarContainer__5amdZ"};